'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadExistingThread = loadExistingThread;

var _selectThread = require('../../selected-thread/actions/selectThread');

var _updateView = require('../../current-view/actions/updateView');

var _views = require('../../current-view/constants/views');

function loadExistingThread(_ref) {
  var threadId = _ref.threadId;

  return function (dispatch) {
    dispatch((0, _selectThread.selectThread)(threadId));

    dispatch((0, _updateView.updateView)(_views.THREAD_VIEW));
  };
}